let swiperGallery = null;

function init(container) {
	const pagination = container.querySelector('.gallery-swiper-footer .swiper-pagination');

	swiperGallery = new Swiper('.js-swiper-gallery', {
		direction: 'horizontal',
		preloadImages: false,
		lazy: {
			loadPrevNext: true,
			loadPrevNextAmount: 5,
			enabled: true,
		},
		slidesPerView: 'auto',
		freeMode: true,
		speed: 1000,
		centeredSlides: true,
		centeredSlidesBounds: true,
		keyboard: {
			enabled: true,
		},
		breakpoints: {
			1025: {
				pagination: false,
				scrollbar: {
					el: '.swiper-scrollbar',
					draggable: true,
				},
			}
		},
		navigation: {
			nextEl: '.gallery-swiper-arrow__right',
			prevEl: '.gallery-swiper-arrow__left',
		},
		pagination: {
			el: pagination,
			clickable: true,
		},
		mousewheel: {
			thresholdDelta: 7,
			thresholdTime: 200,
			enabled: true,
		},
	});
}

function destroy() {
	if (swiperGallery) {
		swiperGallery.destroy();

		swiperGallery = null;
	}
}

function getSliderID() {
	return swiperGallery.activeIndex;
}

export default {
	init,
	destroy,
	getSliderID
}
